module.exports = __webpack_public_path__ + "static/media/plan.b1d4d747.png";